import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { Providers } from "./app/providers";
import { criarQueryClient } from "./app/query-client";
import { criarRouter } from "./app/router";
import { configurarSessaoExpirada } from "./lib/http/cliente";
import "./ui/estilos-globais.css";

/*
 * Bootstrap do painel (FE-0 CP-D — ADR 0026).
 *
 * Ordem: cria QueryClient + router; pluga a navegação real do interceptor
 * (fechamento (a) do CP-C) e monta `<Providers>` (Query) envolvendo o
 * `<RouterProvider>`.
 */
const queryClient = criarQueryClient();
const router = criarRouter();

// Fechamento (a) do CP-C: o interceptor sinaliza "sessão expirada" via
// `onSessaoExpirada`; aqui plugamos a navegação REAL. O `router` de
// `createBrowserRouter` expõe `.navigate()` FORA do React. Path puro "/login" —
// NUNCA token/credencial em rota, query ou log. Roda uma vez no bootstrap.
configurarSessaoExpirada(() => {
  void router.navigate("/login");
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("root element not found");
}

createRoot(container).render(
  <StrictMode>
    <Providers queryClient={queryClient}>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
